// Editorial dates stay fixed across builds and change only when reviewed.
const uvPrintingCostGuide = {
  path: '/guides/uv-printing-cost/',
  title: 'How Much Does UV Printing Cost?',
  publishedDate: '2026-09-11',
  reviewedDate: '2026-09-11',
  reviewedDateLabel: 'September 11, 2026',
}

module.exports = { uvPrintingCostGuide }
